// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Expln_React_Row = require("../../rescript-utils/main/react-mui-components/Expln_React_Row.res.js");
var Expln_React_Column = require("../../rescript-utils/main/react-mui-components/Expln_React_Column.res.js");
var Expln_React_common = require("../../rescript-utils/main/Expln_React_common.res.js");
var Button = require("@mui/material/Button").default;
var TextField = require("@mui/material/TextField").default;

function MM_cmp_multiline_text_input(props) {
  var onCancel = props.onCancel;
  var onOk = props.onOk;
  var __initText = props.initText;
  var initText = __initText !== undefined ? __initText : "";
  var match = React.useState(function () {
        return initText;
      });
  var setText = match[1];
  var text = match[0];
  var actUpdateText = function (text) {
    setText(function (param) {
          return text;
        });
  };
  var rndButtons = function () {
    return React.createElement(Expln_React_Row.make, {
                children: Caml_option.some(null)
              }, React.createElement(Button, {
                    onClick: (function (param) {
                        onOk(text);
                      }),
                    variant: "contained",
                    children: "Ok"
                  }), React.createElement(Button, {
                    onClick: (function (param) {
                        onCancel();
                      }),
                    variant: "outlined",
                    children: "Cancel"
                  }));
  };
  return React.createElement(Expln_React_Column.make, {
              spacing: 1,
              children: Caml_option.some(null)
            }, React.createElement(TextField, {
                  value: text,
                  size: "small",
                  style: {
                    width: "800px"
                  },
                  multiline: true,
                  maxRows: 10,
                  onChange: Expln_React_common.evt2str(actUpdateText),
                  autoFocus: true
                }), rndButtons());
}

var make = MM_cmp_multiline_text_input;

exports.make = make;
/* react Not a pure module */
